
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { nativeType, useDrop } from "../../../Bindings/Fable.ReactDnD.js";
import { item, equalsWith } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { int32ToString, createObj, defaultOf, equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { replace, join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TextValue } from "../../../Components/Text.js";
import { isEmpty, singleton as singleton_1, tryFind, empty as empty_1, toArray, ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Button, TextButton } from "../../../Components/Button.js";
import { ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import { InfiniteTable } from "../../../Widgets/Table/InfiniteTable.js";
import { Select } from "../../../Components/Select.js";
import { unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { SectionContainer } from "../../../Widgets/Container.js";
import { ErrorAlert, InformationAlertContent } from "../../../Components/Alert.js";
import { stockChangeColumnName } from "../../../Shared/Updater.js";
import { Msg } from "./Types.js";
import { TextArea } from "../../../Components/TextArea.js";
import { FormState__getValidation } from "../../../Shared/Shared.js";
import { InformationTooltip } from "../../../Components/InformationTooltip.js";

function UploadArea(props) {
    let elems_3, elems, elems_2, elems_1;
    const patternInput = useTranslation();
    const validateFile = (file) => {
        const formData = new FormData();
        formData.append(file.name, file);
        let identifierValue;
        const matchValue = props.Identifier;
        identifierValue = ((matchValue === "toolId") ? "toolId" : ((matchValue === "name") ? "name" : "inventoryNumber"));
        formData.append("identifier", identifierValue);
        if (props.Identifier2 == null) {
        }
        else {
            formData.append("identifier2", "category");
        }
        props.ValidateFormData(formData);
    };
    const patternInput_1 = useDrop({
        accept: nativeType.FILE,
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedFile) => {
            let testExpr, testExpr_1;
            const matchValue_2 = draggedFile.files;
            if (props.ComponentState === "disabled") {
            }
            else if (matchValue_2 == null) {
            }
            else if ((testExpr = matchValue_2, !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 0))) {
            }
            else if ((testExpr_1 = matchValue_2, !equalsWith(equals, testExpr_1, defaultOf()) && (testExpr_1.length === 1))) {
                const file_1 = item(0, matchValue_2);
                validateFile(file_1);
            }
        },
    });
    const dropData = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: "Upload",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("border"), delay(() => append(singleton("rounded"), delay(() => append(singleton("border-dashed"), delay(() => append(singleton("border-primary"), delay(() => append(singleton("p-4"), delay(() => ((dropData.isOver && dropData.canDrop) ? singleton("bg-background") : empty()))))))))))))))], ["ref", patternInput_1[1]], (elems_2 = [createElement(TextButton, {
        ComponentState: props.ComponentState,
        Label: patternInput[0]("file_upload.select_file"),
        OnClick: () => {
            const element = document.getElementById("twq-stock-file-upload");
            element.click();
        },
        TestId: "open-file-explorer-test-id",
        Variant: "blueButton",
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-center"])], (elems_1 = [reactElement("input", {
        id: "twq-stock-file-upload",
        className: join(" ", ["hidden"]),
        type: "file",
        accept: ".xls, .xlsx",
        disabled: props.ComponentState === "disabled",
        onChange: (ev) => {
            const files = ev.target.files;
            if (!(files == null) && (files.length > 0)) {
                validateFile(files.item(0));
            }
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function rowValidationColumns(t) {
    return [new ColumnDefinition$1("ToolName", "", t("general.name"), (rv) => (new CellContent(0, [rv.ToolName])), "text", "text"), new ColumnDefinition$1("ToolId", "", t("updater.validation_table.id"), (rv_1) => (new CellContent(0, [rv_1.ToolId])), "text", "text"), new ColumnDefinition$1("StorageName", "", t("general.storage"), (rv_2) => (new CellContent(0, [rv_2.StorageName])), "text", "text"), new ColumnDefinition$1("Quantity", "", t("updater.tool_with_quantity_stock.stock_change_header"), (rv_3) => (new CellContent(0, [int32ToString(rv_3.Quantity)])), "text", "text"), new ColumnDefinition$1("IsRowValid", "", t("updater.validation_table.row_status"), (rv_4) => (rv_4.IsRowValid ? (new CellContent(0, [t("updater.validation_table.valid")])) : (new CellContent(0, [t("updater.validation_table.invalid")]))), "select", "text"), new ColumnDefinition$1("ErrorMessage", "", t("updater.validation_row_modal.table_fields.error"), (rv_5) => ((rv_5.ErrorMessage !== "") ? (new CellContent(0, [t(rv_5.ErrorMessage)])) : (new CellContent(0, [""]))), "text", "text")];
}

function ValidationView(props) {
    let elems;
    const t = useTranslation()[0];
    let rowsArray;
    const dependencies_1 = [props.Rows];
    rowsArray = reactApi.useMemo(() => toArray(props.Rows), dependencies_1);
    let rowColumns;
    const dependencies_1_1 = [t];
    rowColumns = reactApi.useMemo(() => rowValidationColumns(t), dependencies_1_1);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems = [createElement(InfiniteTable, {
        ColumnDefinitions: rowColumns,
        Controls: empty_1(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["IsRowValid", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "disabled",
            SaveTableConfiguration: true,
            WithQueryParameters: false,
        },
        TableKey: "updater-twq-stock-validation-overview",
        TableRows: rowsArray,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function IdentifierSelect(props) {
    let elems;
    const t = useTranslation()[0];
    const options = ofArray([{
        label: t("updater.tool_with_quantity_stock.identifier.inventory_number"),
        value: "inventoryNumber",
    }, {
        label: t("updater.tool_with_quantity_stock.identifier.tool_id"),
        value: "toolId",
    }, {
        label: t("updater.tool_with_quantity_stock.identifier.name"),
        value: "name",
    }]);
    const selectedValue = tryFind((o) => (o.value === props.SelectedIdentifier), options);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems = [createElement(Select, {
        ComponentState: props.ComponentState,
        IsClearable: false,
        Label: t("updater.tool_with_quantity_stock.identifier_label"),
        NoOptionsMessage: "general.no_options",
        OnChange: (opt) => {
            if (opt == null) {
            }
            else {
                props.OnChange(opt.value);
            }
        },
        Options: options,
        PlaceholderKey: "updater.tool_with_quantity_stock.identifier_placeholder",
        TestId: "twq-stock-identifier-select",
        Value: unwrap(selectedValue),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function Identifier2Select(props) {
    let elems;
    const t = useTranslation()[0];
    const options = singleton_1({
        label: t("updater.identifier2.category"),
        value: "category",
    });
    let selectedValue;
    const matchValue = props.SelectedIdentifier2;
    if (matchValue == null) {
        selectedValue = undefined;
    }
    else {
        const id2 = matchValue;
        selectedValue = tryFind((o) => (o.value === id2), options);
    }
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems = [createElement(Select, {
        ComponentState: props.ComponentState,
        IsClearable: true,
        Label: t("updater.identifier2_label"),
        NoOptionsMessage: "general.no_options",
        OnChange: (opt) => {
            if (opt == null) {
                props.OnChange(undefined);
            }
            else {
                props.OnChange(opt.value);
            }
        },
        Options: options,
        PlaceholderKey: "updater.identifier2_placeholder",
        TestId: "twq-stock-identifier2-select",
        Value: unwrap(selectedValue),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function View(props) {
    let elems_10;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_10 = toList(delay(() => {
        let Title, elems_7, elems_6, elems_5, elems, elems_4, elems_2, children, children_2, children_4, elems_1, elems_3;
        return append(singleton(createElement(SectionContainer, (Title = t("updater.tool_with_quantity_stock.title"), {
            Content: reactElement("div", createObj(singleton_1((elems_7 = [createElement(InformationAlertContent, {
                Content: replace(t("updater.tool_with_quantity_stock.information_text"), "{{column}}", stockChangeColumnName),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-8"])], (elems_6 = [reactElement("div", createObj(singleton_1((elems_5 = [createElement(IdentifierSelect, {
                ComponentState: componentState,
                OnChange: (id) => {
                    dispatch(new Msg(2, [id]));
                },
                SelectedIdentifier: state_1.SelectedIdentifier,
            }), createElement(Identifier2Select, {
                ComponentState: componentState,
                OnChange: (id2) => {
                    dispatch(new Msg(3, [id2]));
                },
                SelectedIdentifier2: unwrap(state_1.SelectedIdentifier2),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems = [createElement(TextArea, {
                ComponentState: componentState,
                Label: t("updater.tool_with_quantity_stock.comment_label"),
                OnChange: (v) => {
                    dispatch(new Msg(4, [v]));
                },
                TestId: "twq-stock-comment",
                ValidationMessage: unwrap(FormState__getValidation(state_1.FormState, t, "comment")),
                Value: state_1.Comment,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "p-4", "space-y-3"])], (elems_4 = [createElement(TextValue, {
                FontWeight: "bold",
                TestId: "",
                Text: t("updater.tool_with_quantity_stock.excel_columns_title"),
            }), reactElement("ul", createObj(ofArray([["className", join(" ", ["list-disc", "pl-5", "mt-2", "space-y-1"])], (elems_2 = [(children = singleton_1(reactElement("span", {
                children: t("updater.tool_with_quantity_stock.column_identifier"),
            })), reactElement("li", {
                children: reactApi.Children.toArray(Array.from(children)),
            })), (children_2 = singleton_1(reactElement("span", {
                children: t("updater.tool_with_quantity_stock.column_identifier2"),
            })), reactElement("li", {
                children: reactApi.Children.toArray(Array.from(children_2)),
            })), (children_4 = singleton_1(reactElement("span", {
                children: t("updater.tool_with_quantity_stock.column_storage"),
            })), reactElement("li", {
                children: reactApi.Children.toArray(Array.from(children_4)),
            })), reactElement("li", createObj(singleton_1((elems_1 = [reactElement("span", {
                className: join(" ", ["mr-2"]),
                "data-test-id": "twq-stock-column-stock-change",
                children: replace(t("updater.tool_with_quantity_stock.column_quantity"), "{{column}}", stockChangeColumnName),
            }), createElement(InformationTooltip, {
                Content: t("updater.tool_with_quantity_stock.stock_change_tooltip"),
                TestId: "twq-stock-stock-change-tooltip",
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-2"])], (elems_3 = [createElement(TextButton, {
                ComponentState: componentState,
                Label: t("updater.tool_with_quantity_stock.download_template"),
                OnClick: () => {
                    dispatch(new Msg(7, []));
                },
                TestId: "download-twq-stock-template",
                Variant: "blueButton",
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])))), createElement(UploadArea, {
                ComponentState: componentState,
                Identifier: state_1.SelectedIdentifier,
                Identifier2: unwrap(state_1.SelectedIdentifier2),
                ValidateFormData: (formData) => {
                    dispatch(new Msg(5, [formData]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])))),
            Title: unwrap(Title),
        }))), delay(() => {
            let elems_8, Label_2;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "my-5"])], (elems_8 = [createElement(Button, (Label_2 = t("general.upload"), {
                ComponentState: (componentState === "enabled") ? ((isEmpty(state_1.Rows) ? true : (state_1.Comment.trim() === "")) ? "disabled" : componentState) : componentState,
                Label: Label_2,
                OnClick: () => {
                    dispatch(new Msg(0, []));
                },
                TestId: "updater-upload-button",
                Variant: "primary",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                let matchValue, globalValidationMessage, elems_9;
                return append((matchValue = FormState__getValidation(state_1.FormState, t, "global"), (matchValue == null) ? (empty()) : ((globalValidationMessage = matchValue, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_9 = [createElement(ErrorAlert, {
                    Label: globalValidationMessage,
                })], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))))))), delay(() => singleton(createElement(ValidationView, {
                    Rows: state_1.Rows,
                }))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
}

